import './dialpad.scss';

import { Link } from '@sola/ark-core/atoms/link/link.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { NavigationProps } from '@sola/schema/lib/schema.js';

type DialpadProps = {
  item: NavigationProps;
};

export const Dialpad: React.FC<DialpadProps> = ({ item }) => {
  return (
    <ul className="Dialpad gap-comfy-xs">
      {item.items?.map((i) => {
        return (
          <li key={i?.title} className="Dialpad__pad-item flex justify-center">
            <Link
              href={i?.link || '#'}
              target={i?.target}
              className="Dialpad__link w-full flex gap-snug-xl items-center flex-col label p-snug-xl justify-center label label-neutral label-sm label-potent"
              title={i?.title}
            >
              {i?.icon && (
                <ArkIcon iconName={i?.icon} className="Dialpad__icon" />
              )}
              {i?.title}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
